import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-heart-icon',
  templateUrl: './general-heart.component.html'
})
export class GeneralHeartComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
